import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { softwareClassicProformaIssueFormsDirectEmbedRoute } from '@jira/router-routes__classic-projects-routes/src/softwareClassicProformaIssueFormsDirectEmbedRoute.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import ProformaIssueFormsDirectEmbed, {
	LazyProformaIssueFormsDirectEmbed,
} from './ui/proforma/issue-forms-direct/embed/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareClassicProformaIssueFormsDirectEmbedRouteEntry: Route = createEntry(
	softwareClassicProformaIssueFormsDirectEmbedRoute,
	() => ({
		group: 'classic-software',
		// eslint-disable-next-line no-restricted-syntax
		component: ProformaIssueFormsDirectEmbed,
		layout: chromelessLayout,
		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [...jiraSpaResources(), projectContextResource],
		forPaint: [LazyProformaIssueFormsDirectEmbed],
		perfMetricKey: 'issue-forms-direct-embed',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
